import React from 'react';
import { Linkedin, Facebook } from 'lucide-react';
import { socialLinks } from '../data/mockData';
import './SocialRail.css';

const icons = { Linkedin, Facebook };

const SocialRail = () => (
  <div className="social-rail" data-testid="social-rail">
    {socialLinks
      .filter((s) => icons[s.icon])
      .map((social) => {
        const Icon = icons[social.icon];
        return (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-rail-item"
            aria-label={social.name}
            data-testid={`social-rail-${social.name.toLowerCase()}`}
          >
            <Icon size={17} />
          </a>
        );
      })}
  </div>
);

export default SocialRail;
